import { useContext } from 'react';
import { CarbonUserContext } from '../contexts/CarbonUserContext';

// ----------------------------------------------------------------------

const useCarbonUser = () => {
  const context = useContext(CarbonUserContext);

  if (!context) throw new Error('CarbonUser context must be use inside CarbonUserProvider');

  return context;
};

export default useCarbonUser;
